export const errText = (err) => {
  const d = err?.response?.data?.detail;
  if (!d) return '';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return d.msg || String(d);
};

export function AuthField({ icon, type, value, onChange, placeholder, testid, autoComplete }) {
  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500">{icon}</span>
      <input data-testid={testid} type={type} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} autoComplete={autoComplete}
        className="w-full pl-10 pr-3 py-3 rounded-xl bg-slate-900 border border-slate-700 text-white placeholder-slate-500 focus:border-sky-400 outline-none" />
    </div>
  );
}

export const GoogleIcon = () => (
  <svg className="h-4 w-4 mr-2" viewBox="0 0 24 24"><path fill="#EA4335" d="M12 5.4c1.7 0 3.2.6 4.3 1.6l3.2-3.2C17.4 1.8 14.9.8 12 .8 7.4.8 3.4 3.4 1.4 7.3l3.8 3C6.2 7.5 8.9 5.4 12 5.4z"/><path fill="#34A853" d="M12 23.2c2.9 0 5.4-1 7.2-2.7l-3.5-2.7c-1 .7-2.3 1.1-3.7 1.1-3.1 0-5.7-2-6.7-4.9l-3.8 2.9c1.9 3.9 5.9 6.3 10.5 6.3z"/><path fill="#4285F4" d="M23.2 12.3c0-.8-.1-1.6-.2-2.4H12v4.6h6.3c-.3 1.5-1.2 2.7-2.5 3.6l3.5 2.7c2-1.9 3.9-4.7 3.9-8.5z"/><path fill="#FBBC05" d="M5.3 14.1a6.7 6.7 0 0 1 0-4.2l-3.8-3A11.2 11.2 0 0 0 .8 12c0 1.8.4 3.5 1.2 5z"/></svg>
);
